import styled from "styled-components";
import WizardModal from "../wizard-modal/wizard-modal.component";

export const CMUploadModal = styled(WizardModal)((props) => ({
    '& .center-absolute': {
        maxWidth: '660px',
        width: '100%',
    }
}));